export default "__VITE_ASSET__BXrNIyPF__"